/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Steps_AsideInputs */

const en_platform_steps_aside = /** @type {(inputs: Platform_Steps_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About fifteen minutes, and clients can book today.`)
};

const pl_platform_steps_aside = /** @type {(inputs: Platform_Steps_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Około piętnastu minut, a podopieczni mogą rezerwować jeszcze dziś.`)
};

/**
* | output |
* | --- |
* | "About fifteen minutes, and clients can book today." |
*
* @param {Platform_Steps_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_steps_aside = /** @type {((inputs?: Platform_Steps_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Steps_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_steps_aside(inputs)
	return en_platform_steps_aside(inputs)
});